import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Welcome from './pages/Welcome';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Tournaments from './pages/Tournaments';
import TournamentDetail from './pages/TournamentDetail';
import Players from './pages/Players';
import LiveMatch from './pages/LiveMatch';
import Leaderboard from './pages/Leaderboard';
import PublicLiveScores from './pages/PublicLiveScores';
import AdminManagement from './pages/AdminManagement';
import TournamentResults from './pages/TournamentResults';

function ProtectedRoute({ children }) {
  const { admin } = useAuth();
  return admin ? children : <Navigate to="/" replace />;
}

function AppRoutes() {
  const { admin } = useAuth();
  return (
    <BrowserRouter basename={process.env.REACT_APP_BASENAME || '/'}>
      {admin && <Navbar />}
      <div style={{ paddingTop: admin ? '64px' : '0', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={admin ? <Navigate to="/dashboard" replace /> : <Welcome />} />
            <Route path="/login" element={admin ? <Navigate to="/dashboard" /> : <Login />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/tournaments" element={<ProtectedRoute><Tournaments /></ProtectedRoute>} />
            <Route path="/tournaments/:id" element={<ProtectedRoute><TournamentDetail /></ProtectedRoute>} />
            <Route path="/players" element={<ProtectedRoute><Players /></ProtectedRoute>} />
            <Route path="/admin-management" element={<ProtectedRoute><AdminManagement /></ProtectedRoute>} />
            <Route path="/matches/:id/live" element={<LiveMatch />} />
            <Route path="/live-scores" element={<PublicLiveScores />} />
            <Route path="/tournament-results/:id" element={<TournamentResults />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="*" element={<Navigate to={admin ? '/dashboard' : '/'} />} />
          </Routes>
        </div>
        {admin && <Footer />}
      </div>
    </BrowserRouter>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}
